import { fromUnits, scaleUp } from "logic/utils";
import { AmountTooltip, Input } from "ui/components";

import { calcLoanPaymentSchedule } from "../../PaymentSchedule/calcPaymentSchedule/index";
import { Row } from "../components";

import { useLoanPayment } from "./LoanPaymentProvider";
import { MonthlyPayment } from "./MonthlyPayment";

export function Prepayment() {
  const {
    loan,
    customPaymentAmount,
    setCustomPaymentAmount,
    customPaymentAmountUnits,
    quote,
    isQuoteUnavailable,
    loanTimestamps,
    maxToRepay,
    customPaymentAmountError,
  } = useLoanPayment();

  let prepaymentAmount = customPaymentAmountUnits;
  let totalPrincipalReduced = customPaymentAmountUnits;

  if (loanTimestamps.isRepayment) {
    prepaymentAmount -= quote?.total ?? 0n;
    if (prepaymentAmount < 0n) prepaymentAmount = 0n;

    totalPrincipalReduced -= quote?.interest ?? 0n;
    if (totalPrincipalReduced < 0n) totalPrincipalReduced = 0n;
  }

  let futureInterestSavings = 0n;
  if (prepaymentAmount) {
    const currentSchedule = calcLoanPaymentSchedule(loan);
    const reducedBalance = loan.loanState.scaledBalance - scaleUp(prepaymentAmount, loan.erc20.decimals);
    const newSchedule = calcLoanPaymentSchedule(loan, reducedBalance);

    futureInterestSavings = currentSchedule.totalInterest - newSchedule.totalInterest;
  }

  // Without a trustworthy quote there is no floor to validate the input against,
  // so the amount entry is locked alongside the payment button.
  const isDisabled = loanTimestamps.isGracePeriod || isQuoteUnavailable;

  return (
    <>
      <div className="flex flex-col gap-2 mb-5">
        <div className="flex items-center justify-between ">
          <span className="text-text-secondary">Enter amount</span>

          {!isDisabled ? (
            <button
              type="button"
              onClick={() =>
                setCustomPaymentAmount(fromUnits(maxToRepay, loan.erc20.decimals).toFixed(loan.erc20.decimals))
              }
              className="text-text-secondary text-xs"
            >
              MAX
            </button>
          ) : null}
        </div>

        <Input
          type="number"
          onChange={setCustomPaymentAmount}
          value={customPaymentAmount}
          inputClassName="text-end"
          error={customPaymentAmountError && true}
          disabled={isDisabled}
        />
        <div className="h-6">
          <span className="text-red-500 text-xs">{customPaymentAmountError}</span>
        </div>
      </div>

      <MonthlyPayment />

      <Row
        label="Prepayment of Principal"
        value={quote && <AmountTooltip amount={prepaymentAmount} decimals={loan.erc20.decimals} />}
        className="mt-4"
      />

      <div className="flex flex-col border-t border-b gap-2 mt-4 py-3">
        <Row
          label="Total Principal Reduced"
          value={quote && <AmountTooltip amount={totalPrincipalReduced} decimals={loan.erc20.decimals} />}
          className="text-text-secondary"
        />

        <Row
          label="Future Interest Savings"
          value={quote && <AmountTooltip amount={futureInterestSavings} decimals={loan.erc20.decimals} />}
          className="text-text-secondary text-xs"
        />
      </div>
    </>
  );
}
